/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoModelsCustomWarning,
    MelcoModelsCustomWarningFromJSON,
    MelcoModelsCustomWarningFromJSONTyped,
    MelcoModelsCustomWarningToJSON,
    MelcoModelsHoopCategory,
    MelcoModelsHoopCategoryFromJSON,
    MelcoModelsHoopCategoryFromJSONTyped,
    MelcoModelsHoopCategoryToJSON,
    MelcoModelsHoopMachine,
    MelcoModelsHoopMachineFromJSON,
    MelcoModelsHoopMachineFromJSONTyped,
    MelcoModelsHoopMachineToJSON,
    MelcoModelsHoopProduct,
    MelcoModelsHoopProductFromJSON,
    MelcoModelsHoopProductFromJSONTyped,
    MelcoModelsHoopProductToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoModelsHoop
 */
export interface MelcoModelsHoop {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    english_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    metric_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsHoop
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsHoop
     */
    width_points?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsHoop
     */
    height_points?: number;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    presser_foot?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsHoop
     */
    enable_templates?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    backward_compatibility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    supplier_product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    supplier_product_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    asset_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    type?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoModelsHoop
     */
    discontinued?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsHoop
     */
    publish_state?: number;
    /**
     * 
     * @type {Array<MelcoModelsHoopCategory>}
     * @memberof MelcoModelsHoop
     */
    category_list?: Array<MelcoModelsHoopCategory> | null;
    /**
     * 
     * @type {Array<MelcoModelsHoopProduct>}
     * @memberof MelcoModelsHoop
     */
    product_list?: Array<MelcoModelsHoopProduct> | null;
    /**
     * 
     * @type {Array<MelcoModelsHoopMachine>}
     * @memberof MelcoModelsHoop
     */
    machine_list?: Array<MelcoModelsHoopMachine> | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsHoop
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsHoop
     */
    published_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof MelcoModelsHoop
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    asset?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsHoop
     */
    signature?: string | null;
    /**
     * 
     * @type {Array<MelcoModelsCustomWarning>}
     * @memberof MelcoModelsHoop
     */
    warning_list?: Array<MelcoModelsCustomWarning> | null;
}

export function MelcoModelsHoopFromJSON(json: any): MelcoModelsHoop {
    return MelcoModelsHoopFromJSONTyped(json, false);
}

export function MelcoModelsHoopFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsHoop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'english_name': !exists(json, 'english_name') ? undefined : json['english_name'],
        'metric_name': !exists(json, 'metric_name') ? undefined : json['metric_name'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'width_points': !exists(json, 'width_points') ? undefined : json['width_points'],
        'height_points': !exists(json, 'height_points') ? undefined : json['height_points'],
        'presser_foot': !exists(json, 'presser_foot') ? undefined : json['presser_foot'],
        'enable_templates': !exists(json, 'enable_templates') ? undefined : json['enable_templates'],
        'backward_compatibility_id': !exists(json, 'backward_compatibility_id') ? undefined : json['backward_compatibility_id'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'supplier_product_id': !exists(json, 'supplier_product_id') ? undefined : json['supplier_product_id'],
        'supplier_product_name': !exists(json, 'supplier_product_name') ? undefined : json['supplier_product_name'],
        'asset_type': !exists(json, 'asset_type') ? undefined : json['asset_type'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'discontinued': !exists(json, 'discontinued') ? undefined : json['discontinued'],
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'category_list': !exists(json, 'category_list') ? undefined : (json['category_list'] === null ? null : (json['category_list'] as Array<any>).map(MelcoModelsHoopCategoryFromJSON)),
        'product_list': !exists(json, 'product_list') ? undefined : (json['product_list'] === null ? null : (json['product_list'] as Array<any>).map(MelcoModelsHoopProductFromJSON)),
        'machine_list': !exists(json, 'machine_list') ? undefined : (json['machine_list'] === null ? null : (json['machine_list'] as Array<any>).map(MelcoModelsHoopMachineFromJSON)),
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'published_date': !exists(json, 'published_date') ? undefined : (json['published_date'] === null ? null : new Date(json['published_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(MelcoModelsCustomWarningFromJSON)),
    };
}

export function MelcoModelsHoopToJSON(value?: MelcoModelsHoop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'english_name': value.english_name,
        'metric_name': value.metric_name,
        'version': value.version,
        'width_points': value.width_points,
        'height_points': value.height_points,
        'presser_foot': value.presser_foot,
        'enable_templates': value.enable_templates,
        'backward_compatibility_id': value.backward_compatibility_id,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'supplier_product_id': value.supplier_product_id,
        'supplier_product_name': value.supplier_product_name,
        'asset_type': value.asset_type,
        'type': value.type,
        'discontinued': value.discontinued,
        'publish_state': value.publish_state,
        'category_list': value.category_list === undefined ? undefined : (value.category_list === null ? null : (value.category_list as Array<any>).map(MelcoModelsHoopCategoryToJSON)),
        'product_list': value.product_list === undefined ? undefined : (value.product_list === null ? null : (value.product_list as Array<any>).map(MelcoModelsHoopProductToJSON)),
        'machine_list': value.machine_list === undefined ? undefined : (value.machine_list === null ? null : (value.machine_list as Array<any>).map(MelcoModelsHoopMachineToJSON)),
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'published_date': value.published_date === undefined ? undefined : (value.published_date === null ? null : value.published_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'asset': value.asset,
        'signature': value.signature,
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(MelcoModelsCustomWarningToJSON)),
    };
}


